// AUTO-GENERATED SQL Builder (V40 Final) for PaymentTransfer
import { 
  SqlField, 
  SqlExp, 
  SqlExpChain, 
  SqlFn, 
  SqlLiteral, 
  SqlSubQuery, 
  SqlApplyColumn, 
  SqlNavHybrid, 
  createNavHybrid 
} from '../utils/sql-core';
import { SqlAst } from '../utils/sql-ast';

export class PaymentTransferSql {
  private ast = new SqlAst('PaymentTransfer', 'paymentTransfer');
  public readonly main: any = {};

  public guid: SqlField;
  public paymentId: SqlField;
  public bookingId: SqlField;
  public bookingPackageId: SqlField;
  public vendorId: SqlField;
  public vendorPayoutAccountId: SqlField;
  public transferRef: SqlField;
  public amount: SqlField;
  public feeAmount: SqlField;
  public onHold: SqlField;
  public onHoldUntil: SqlField;
  public status: SqlField;
  public reversedAmount: SqlField;
  public settlementRef: SqlField;
  public processedDate: SqlField;
  public kind: SqlField;
  public ledgerEntryId: SqlField;
  public isSimulated: SqlField;
  public settlementStatus: SqlField;
  public failureReason: SqlField;
  public rawJson: SqlField;
  public payment: SqlNavHybrid;
  public booking: SqlNavHybrid;
  public bookingPackage: SqlNavHybrid;
  public vendor: SqlNavHybrid;
  public vendorPayoutAccount: SqlNavHybrid;
  public ledgerEntry: SqlNavHybrid;
  public createdByUser: SqlNavHybrid;
  public updatedByUser: SqlNavHybrid;
  public ledgerEntryList: SqlNavHybrid;
  public id: SqlField;
  public isDeleted: SqlField;
  public createdBy: SqlField;
  public createdDate: SqlField;
  public updatedBy: SqlField;
  public updatedDate: SqlField;

  constructor() {
    this.guid = new SqlField('paymentTransfer', 'guid', '', 'id', 'paymentTransfer_guid');
    this.paymentId = new SqlField('paymentTransfer', 'paymentId', 'payment', 'id', 'paymentTransfer_payment');
    this.bookingId = new SqlField('paymentTransfer', 'bookingId', 'booking', 'id', 'paymentTransfer_booking');
    this.bookingPackageId = new SqlField('paymentTransfer', 'bookingPackageId', 'bookingPackage', 'id', 'paymentTransfer_bookingPackage');
    this.vendorId = new SqlField('paymentTransfer', 'vendorId', 'vendor', 'id', 'paymentTransfer_vendor');
    this.vendorPayoutAccountId = new SqlField('paymentTransfer', 'vendorPayoutAccountId', 'vendorPayoutAccount', 'id', 'paymentTransfer_vendorPayoutAccount');
    this.transferRef = new SqlField('paymentTransfer', 'transferRef', '', 'id', 'paymentTransfer_transferRef');
    this.amount = new SqlField('paymentTransfer', 'amount', '', 'id', 'paymentTransfer_amount');
    this.feeAmount = new SqlField('paymentTransfer', 'feeAmount', '', 'id', 'paymentTransfer_feeAmount');
    this.onHold = new SqlField('paymentTransfer', 'onHold', '', 'id', 'paymentTransfer_onHold');
    this.onHoldUntil = new SqlField('paymentTransfer', 'onHoldUntil', '', 'id', 'paymentTransfer_onHoldUntil');
    this.status = new SqlField('paymentTransfer', 'status', '', 'id', 'paymentTransfer_status');
    this.reversedAmount = new SqlField('paymentTransfer', 'reversedAmount', '', 'id', 'paymentTransfer_reversedAmount');
    this.settlementRef = new SqlField('paymentTransfer', 'settlementRef', '', 'id', 'paymentTransfer_settlementRef');
    this.processedDate = new SqlField('paymentTransfer', 'processedDate', '', 'id', 'paymentTransfer_processedDate');
    this.kind = new SqlField('paymentTransfer', 'kind', '', 'id', 'paymentTransfer_kind');
    this.ledgerEntryId = new SqlField('paymentTransfer', 'ledgerEntryId', 'ledgerEntry', 'id', 'paymentTransfer_ledgerEntry');
    this.isSimulated = new SqlField('paymentTransfer', 'isSimulated', '', 'id', 'paymentTransfer_isSimulated');
    this.settlementStatus = new SqlField('paymentTransfer', 'settlementStatus', '', 'id', 'paymentTransfer_settlementStatus');
    this.failureReason = new SqlField('paymentTransfer', 'failureReason', '', 'id', 'paymentTransfer_failureReason');
    this.rawJson = new SqlField('paymentTransfer', 'rawJson', '', 'id', 'paymentTransfer_rawJson');
    this.payment = createNavHybrid('paymentTransfer', 'paymentTransfer_payment', 'Payment');
    this.booking = createNavHybrid('paymentTransfer', 'paymentTransfer_booking', 'Booking');
    this.bookingPackage = createNavHybrid('paymentTransfer', 'paymentTransfer_bookingPackage', 'BookingPackage');
    this.vendor = createNavHybrid('paymentTransfer', 'paymentTransfer_vendor', 'Vendor');
    this.vendorPayoutAccount = createNavHybrid('paymentTransfer', 'paymentTransfer_vendorPayoutAccount', 'VendorPayoutAccount');
    this.ledgerEntry = createNavHybrid('paymentTransfer', 'paymentTransfer_ledgerEntry', 'LedgerEntry');
    this.createdByUser = createNavHybrid('paymentTransfer', 'paymentTransfer_createdByUser', 'User');
    this.updatedByUser = createNavHybrid('paymentTransfer', 'paymentTransfer_updatedByUser', 'User');
    this.ledgerEntryList = createNavHybrid('paymentTransfer', 'paymentTransfer_ledgerEntryList', 'LedgerEntry');
    this.id = new SqlField('paymentTransfer', 'id', '', 'id', 'paymentTransfer_id');
    this.isDeleted = new SqlField('paymentTransfer', 'isDeleted', '', 'id', 'paymentTransfer_isDeleted');
    this.createdBy = new SqlField('paymentTransfer', 'createdBy', '', 'id', 'paymentTransfer_createdBy');
    this.createdDate = new SqlField('paymentTransfer', 'createdDate', '', 'id', 'paymentTransfer_createdDate');
    this.updatedBy = new SqlField('paymentTransfer', 'updatedBy', '', 'id', 'paymentTransfer_updatedBy');
    this.updatedDate = new SqlField('paymentTransfer', 'updatedDate', '', 'id', 'paymentTransfer_updatedDate');

    for (const k of Object.keys(this)) {
      const v = (this as any)[k];
      if (v instanceof SqlField) this.main[k] = v;
    }
  }

  // SELECT
  select(fn:(x:PaymentTransferSql)=>any) {
    this.ast.addSelectObject(fn(this));
    return this;
  }

  // WHERE
  where(fn:(x:PaymentTransferSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  and(fn:(x:PaymentTransferSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  or(fn:(x:PaymentTransferSql)=>SqlExp | SqlExpChain) {
    this.ast.addOr(fn(this));
    return this;
  }

  // JOIN
  join(fn:(x:PaymentTransferSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f);
    return this;
  }
  leftJoin(fn:(x:PaymentTransferSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'LEFT');
    return this;
  }
  rightJoin(fn:(x:PaymentTransferSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'RIGHT');
    return this;
  }

  // AND JOIN
  andJoin(fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    const last = this.ast.joins[this.ast.joins.length - 1];
    if (!last) throw new Error('andJoin() before join()');

    const left = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(this.ast.alias, prop)
    });
    const right = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(last.alias, prop)
    });

    const exp = (this.ast as any).compileExp(fn(left, right));

    if (typeof last.on === 'string') {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[
          { column:last.on, operator:'', value:null, isTrusted:true, subFilters:[] },
          exp
        ]
      };
    }
    else if (last.on.logic === 'And') {
      last.on.subFilters.push(exp);
    }
    else {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[ last.on, exp ]
      };
    }

    return this;
  }

  // CTE
  with(name:string, fn:(c:any)=>any) {
    this.ast.with(name, fn);
    return this;
  }
  withRecursive(name:string, fn:(c:any)=>any) {
    this.ast.withRecursive(name, fn);
    return this;
  }

  // CTE JOIN
  joinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.joinCTE(name, alias, fn);
    return this;
  }
  fullJoinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.fullJoinCTE(name, alias, fn);
    return this;
  }

  // SUBQUERY
  subQuery(fn:(b:any)=>any) {
    return new SqlSubQuery(fn);
  }

  // APPLY
  apply(name:string, fn:(b:any)=>any) {
    this.ast.apply(name, fn);
    return this;
  }
  applyColumn(name:string, fn:(b:any)=>SqlField) {
    return this.ast.applyColumn(name, fn);
  }
  crossApply(app:any) {
    this.ast.crossApply(app);
    return this;
  }

  // GROUP BY
  groupBy(fn:(x:PaymentTransferSql)=>SqlField[]) {
    this.ast.addGroup(fn(this));
    return this;
  }

  // HAVING
  having(fn:(x:PaymentTransferSql)=>SqlExp | SqlExpChain) {
    this.ast.addHaving(fn(this));
    return this;
  }

  // ORDER
  orderBy(fn:(x:PaymentTransferSql)=>any[]) {
    this.ast.addOrder(fn(this));
    return this;
  }

  // UNION
  union(fn:(q:any)=>any) {
    this.ast.union(fn);
    return this;
  }
  unionAll(fn:(q:any)=>any) {
    this.ast.unionAll(fn);
    return this;
  }

  limit(n:number) { this.ast.take = n; return this; }
  offset(n:number) { this.ast.skip = n; return this; }

  build() {
    return this.ast.toQueryDescriptor();
  }
}
